import React from 'react';
import styled, { css } from 'styled-components';
import { connect } from 'react-redux';
import { _ } from '_locales';
import images from '_images';
import { colors } from '_styles';
// import parse from 'html-react-parser';
import {
  eventTracker,
  // goToTop
} from '_helpers';
import RcLogo from '../images/rc-logo.png';

// import styles
import { triggerCampaign } from '../pages/Campaign/redux/actions';

const parentWidth = document.getElementById('rcroot').getBoundingClientRect().width;

const Container = styled.div`
  padding: 0;
  height: auto;
  overflow: hidden;
  background-color: #fff;
  width: 100%;
  border-radius: 10px;
  box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
`;

const Text = styled.p`
  margin: 0;
  font-weight: 400 !important;
  font-size: 15px !important;
  line-height: 1.5em;
  color: #000 !important;
`;

const Link = styled.a`
  color: ${colors.RC_ACTION} !important;

  &:hover {
    color: ${colors.RC_ACTION} !important;
  }
`;

const ContentWrapper = styled.div`
  overflow: hidden;
  border: 1px solid #E7ECEF;
  padding: 7px;
  box-sizing: border-box;
  display: flex;
  align-items: center;

  ${(parentWidth < 501) && css`
    border:none;
    height: auto;
    overflow:hidden;
    display:initial;
  `};
`;

const RcawWrapper = styled.div`
  display: flex;
  align-items: center;
  flex: 1;
  max-width: ${({ hasCampaign }) => ((hasCampaign) ? '105px' : '60px')};
  margin-right: 17px;

  ${(parentWidth < 501) && css`
    display: none;
    margin-right: 0;
  `};
`;

const RcawIcon = styled.img`
  width: 90px;
`;

const TextWrapper = styled.div`
  flex-grow: 1;
  padding-top: 5px;
  margin-right: 17px;
  margin-left: 35px;

  ${(parentWidth < 501) && css`
    display: block;
    padding: 0 6px;
    margin: 0 auto;
    margin-right: 0;

    p {
      font-size: 15px !important;
      line-height: 1.7em;
      text-align: center;
      padding: 0;
    }

  `};
`;

const DownloadButtonWrapper = styled.div`
  padding-top: ${({ hasCampaign }) => ((hasCampaign) ? '10px' : '5px')};
  justify-content: center;
  gap: 5px;
  display: flex;
  flex-grow: 1;
  align-items:center;

  ${(parentWidth < 750) && css`
    flex-direction: column;
    gap: 0px;
  `};

  ${(parentWidth < 501) && css`
    margin: 0 auto;
    margin-top: 15px;
    text-align: center;
    flex-direction: row;
    gap: 5px;
  `};
`;

const IOSLink = styled.a``;

const AndroidLink = styled.a``;

const IOSImage = styled.img`
  width: 110px;
`;

const AndroidImage = styled.img`
  width: 110px;
`;
// End style

// eslint-disable-next-line no-empty-pattern
const DownloadAppBanner = ({
  // hasCampaign,
  // campaignPrompt,
  // activateCampaign,
}) => (
  <Container>
    <ContentWrapper>
      <RcawWrapper>
        <RcawIcon
          // hasCampaign={hasCampaign}
          src={RcLogo}
          alt="Recycle Coach Logo"
        />
      </RcawWrapper>

      <TextWrapper>
        {/* {
        hasCampaign && campaignPrompt
          ? (
            <CampaignButton
              onClick={() => [
                eventTracker('Plugin Click', {
                  action: 'campaign', title: 'Campaign', param: 'campaign_start_channel_start'
                }),
                activateCampaign(),
                goToTop(),
              ]}
              aria-label="click to visit the campaign"
            >
              {parse(campaignPrompt)}
            </CampaignButton>
          ) : null
      } */}
        <Text>
          {_('general.weve_been_taught_to_recycle')}
          &nbsp;
          {_('general.download')}
          &nbsp;
          <Link href="https://recyclecoach.com/" target="_blank" rel="noreferrer" alt="recycle coach link" title="recycle coach link">
            Recycle Coach
          </Link>
          &nbsp;
          {_('general.app')}
          .
        </Text>
      </TextWrapper>

      <DownloadButtonWrapper>
        <IOSLink
          target="_blank"
          onClick={() => eventTracker('APP_DOWNLOAD_LINK_CLICK', 'ios')}
          href="https://apps.apple.com/us/app/recyclecoach/id1071714967"
          rel="noreferrer"
          alt="download ios app"
          title="ios download link"
        >
          <IOSImage
            // hasCampaign={hasCampaign}
            src={images.iosLogo}
            alt="download app for ios"
          />
        </IOSLink>

        <AndroidLink
          target="_blank"
          onClick={() => eventTracker('APP_DOWNLOAD_LINK_CLICK', 'android')}
          href="https://play.google.com/store/apps/details?id=mobi.recyclecoach.worldster.pack"
          rel="noreferrer"
          alt="download android app"
          title="android download link"
        >
          <AndroidImage
            // hasCampaign={hasCampaign}
            src={images.androidLogo}
            alt="download app for android"
          />
        </AndroidLink>
      </DownloadButtonWrapper>
    </ContentWrapper>
  </Container>
);

const mapStateToProps = (store) => ({
  hasCampaign: store.campaign.hasActiveCampaign || false,
  campaignPrompt: store.campaign.campaignPrompt || '',
  selectedLang: store.config.selectedLang,
});

export default connect(
  mapStateToProps,
  (dispatch) => ({
    activateCampaign: () => dispatch(triggerCampaign(true))
  })
)(DownloadAppBanner);
